import React from 'react';
import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import EmergencyShareRoundedIcon from '@mui/icons-material/EmergencyShareRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded';

// Single source of truth for navigation. Consumed by the sidebar, the mobile
// bottom nav, and the top bar page-title lookup.
export const NAV_SECTIONS = [
  {
    label: 'Overview',
    items: [
      {
        text: 'Dashboard',
        shortText: 'Home',
        icon: <SpaceDashboardRoundedIcon />,
        path: '/',
        roles: ['admin', 'manager', 'employee', 'blog_manager', 'claims_manager'],
      },
    ],
  },
  {
    label: 'Operations',
    items: [
      {
        text: 'Customers',
        icon: <PeopleAltRoundedIcon />,
        path: '/customers',
        roles: ['admin', 'manager', 'claims_manager'],
      },
      {
        text: 'Emergency',
        icon: <EmergencyShareRoundedIcon />,
        path: '/emergency-requests',
        highlight: true,
        roles: ['admin', 'manager', 'claims_manager'],
      },
      {
        text: 'Appointments',
        shortText: 'Schedule',
        icon: <EventRoundedIcon />,
        path: '/appointments',
        roles: ['admin', 'manager', 'claims_manager'],
      },
      {
        text: 'Assessments',
        icon: <FactCheckRoundedIcon />,
        path: '/assessments',
        roles: ['admin', 'manager', 'claims_manager'],
      },
    ],
  },
  {
    label: 'Management',
    items: [
      {
        text: 'Blog',
        icon: <ArticleRoundedIcon />,
        path: '/blog',
        roles: ['admin', 'manager', 'blog_manager'],
      },
      {
        text: 'Users',
        icon: <ManageAccountsRoundedIcon />,
        path: '/users',
        roles: ['admin'],
      },
      {
        text: 'Settings',
        icon: <SettingsRoundedIcon />,
        path: '/settings',
        roles: ['admin', 'manager'],
      },
      {
        text: 'Diagnostics',
        icon: <MonitorHeartRoundedIcon />,
        path: '/diagnostics',
        roles: ['admin'],
      },
    ],
  },
];

export const hasAccess = (item, role) => {
  if (!item.roles) return true;
  return item.roles.includes(role);
};

export const isPathActive = (path, pathname) => {
  if (path === '/') return pathname === '/';
  return pathname.startsWith(path);
};

// Flat list of items a given role can see, in display order.
export const visibleNavItems = (role) =>
  NAV_SECTIONS.flatMap((section) => section.items).filter((item) => hasAccess(item, role));

// Best-matching nav entry for a pathname (used for the top bar title).
export const activeNavItem = (pathname) => {
  const all = NAV_SECTIONS.flatMap((section) => section.items);
  return (
    all.find((item) => item.path !== '/' && pathname.startsWith(item.path)) ||
    (pathname === '/' ? all[0] : undefined)
  );
};
